import { CoverageChipGroup as CoverageChipGroupSchema } from '@/schemas/sceneDataSchema';
import { BaseChipElement } from './BaseChipElement';
import { useCoverageAttribute } from '@/hooks/use-quote';
import { useCallback } from 'react';

export const CoverageChipFormElement = ({ component }: { component: CoverageChipGroupSchema }) => {
  const { options, findSelectedIndex, handleSelectByIndex } = useCoverageAttribute({
    symbol: component.symbol,
    scope: component.scope,
    kind: component.kind,
  });

  const chipOptions = options.map((opt, idx) => ({
    value: idx,
    label: opt.label,
  }));

  const selectedIndex = findSelectedIndex();

  const handleChange = useCallback(
    (value: string | number | boolean | null) => {
      if (typeof value === 'number') {
        handleSelectByIndex(value);
      }
    },
    [handleSelectByIndex]
  );

  return (
    <BaseChipElement
      onChange={handleChange}
      options={chipOptions}
      value={selectedIndex >= 0 ? selectedIndex : null}
    />
  );
};
